import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["intervalButton", "customRange", "startDate", "endDate", "loadingOverlay"]
  declare readonly intervalButtonTargets: HTMLElement[]
  declare readonly loadingOverlayTarget: HTMLElement
  declare readonly startDateTarget: HTMLInputElement
  declare readonly endDateTarget: HTMLInputElement
  declare readonly customRangeTarget: HTMLElement

  connect() {
    // No longer using localStorage for filters
  }

  setInterval(event: MouseEvent) {
    const button = event.currentTarget as HTMLElement
    const interval = button.dataset.interval

    if (interval === "custom") {
      event.preventDefault()
      this.showCustomRange()
      this.setActiveButton("custom")
    } else {
      event.preventDefault()
      this.setActiveButton(interval!)
      this.updateChart(interval!)
    }
  }

  applyCustomRange() {
    const start = this.startDateTarget.value
    const end = this.endDateTarget.value

    if (start && end) {
      this.updateChart("custom", start, end)
    }
  }

  updateChart(interval: string, start?: string, end?: string) {
    const url = new URL(window.location.href)
    
    if (interval === "custom") {
      url.searchParams.set("start_date", start!)
      url.searchParams.set("end_date", end!)
    } else {
      const days = parseInt(interval)
      const endDate = new Date()
      const startDate = new Date()
      startDate.setDate(endDate.getDate() - days)

      url.searchParams.set("start_date", startDate.toISOString().split('T')[0])
      url.searchParams.set("end_date", endDate.toISOString().split('T')[0])
    }

    // Show loading state
    this.showLoading()

    // Update the frame src instead of full page visit
    const frame = document.getElementById("operational_health_chart") as any
    if (frame) {
      const newSrc = url.toString()
      if (frame.src === newSrc) {
        this.hideLoading()
        return
      }
      frame.src = newSrc
    } else {
      Turbo.visit(url.toString(), { action: "replace" })
    }
  }

  showLoading() {
    this.loadingOverlayTarget.classList.remove("hidden")
    this.intervalButtonTargets.forEach(btn => (btn as HTMLButtonElement).disabled = true)
  }

  hideLoading() {
    this.loadingOverlayTarget.classList.add("hidden")
    this.intervalButtonTargets.forEach(btn => (btn as HTMLButtonElement).disabled = false)
  }

  setActiveButton(interval: string) {
    this.intervalButtonTargets.forEach(btn => {
      if (btn.dataset.interval === interval) {
        btn.classList.add("bg-blue-600", "text-white")
        btn.classList.remove("bg-gray-100", "text-gray-600")
      } else {
        btn.classList.remove("bg-blue-600", "text-white")
        btn.classList.add("bg-gray-100", "text-gray-600")
      }
    })
  }

  showCustomRange() {
    this.customRangeTarget.classList.remove("hidden")
    this.customRangeTarget.classList.add("flex")
  }

  hideCustomRange() {
    this.customRangeTarget.classList.add("hidden")
    this.customRangeTarget.classList.remove("flex")
  }
}
